import { Component, Input } from '@angular/core';
import { OrderMaterial, RelocationDetail, RelocationPlanning, } from '../../../core/store/edit-florder-detail/florder-detail.interface';
import { FlorderEditDetailComponent } from '../../florder/florder-edit-detail/florder-edit-detail.component';
import { ScrollService } from '../../../core/services/scroll.service';

@Component({
  selector: 'app-relocation-edit-detail',
  templateUrl: './relocation-edit-detail.component.html',
  styleUrls: ['../../florder/florder-edit-detail/florder-edit-detail.component.scss'],
})
export class RelocationEditDetailComponent extends FlorderEditDetailComponent<OrderMaterial, RelocationDetail, RelocationPlanning> {
  @Input() relocationDetail: RelocationDetail;

  get florderDetail(): RelocationDetail {
    return this.relocationDetail;
  }

  constructor(scrollService: ScrollService) {
    super(scrollService);
  }
}
